import { TThunkAction } from '../../types/redux';
import { validateFilters } from '@cian/valuation-main-filters-widget';
import { checkEstimationExistsRequest, checkEstimationExistsRequestError, resetCheckEstimationExists } from './actions';

import {
  fetchCheckEstimationExists,
  ICheckEstimationExistsResponse200,
  ICheckEstimationExistsResponse400,
} from '../../repositories/price-estimator/v1/check-estimation-exists';

export const checkEstimationExists = (): TThunkAction<Promise<boolean>> => {
  return async (dispatch, getState, context) => {
    dispatch(checkEstimationExistsRequest());

    const isFormValid = await dispatch((validateFilters() as unknown) as TThunkAction<Promise<boolean>>);

    if (!isFormValid) {
      dispatch(resetCheckEstimationExists());

      return false;
    }

    /**
     * houseId появится только после валидации
     * поэтому getState стоит вызывать уже после валидации
     */
    const {
      filters: { roomsCount, area, houseId },
    } = getState();
    const { httpApi, logger } = context;

    try {
      const res = await fetchCheckEstimationExists<
        ICheckEstimationExistsResponse200,
        ICheckEstimationExistsResponse400
      >({
        httpApi,
        parameters: {
          houseId: houseId as number,
          roomsCount: roomsCount as number,
          area: area as number,
        },
      });

      if (res.statusCode === 200 && res.response.exists) {
        return true;
      }

      dispatch(checkEstimationExistsRequestError());

      return false;
    } catch (e) {
      logger.error('Unable to check estimation exists', e);
      dispatch(checkEstimationExistsRequestError());

      return false;
    }
  };
};
